module.exports = __webpack_public_path__ + "static/media/calvin.044eb684.svg";